"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _combineParentAndChildFilters = _interopRequireDefault(require("./combineParentAndChildFilters"));

var _getMatrix = _interopRequireDefault(require("./getMatrix"));

var combineParentAndChildTransforms = function combineParentAndChildTransforms(parentTransform, childTransform) {
  var alpha = childTransform.alpha,
      childFilters = childTransform.filters,
      rotation = childTransform.rotation,
      _childTransform$scale = childTransform.scale,
      scaleX = _childTransform$scale.x,
      scaleY = _childTransform$scale.y,
      _childTransform$trans = childTransform.translation,
      translateX = _childTransform$trans.x,
      translateY = _childTransform$trans.y; // Note, this order or operations matters see preview-canvas/snapPreview/imageData/README.md

  var elementTransformMatrix = (0, _getMatrix["default"])(scaleX, scaleY, translateX, translateY, rotation);
  var parentAlpha = parentTransform.alpha,
      parentFilters = parentTransform.filters,
      parentRotation = parentTransform.rotation,
      _parentTransform$scal = parentTransform.scale,
      parentScaleX = _parentTransform$scal.x,
      parentScaleY = _parentTransform$scal.y,
      _parentTransform$tran = parentTransform.translation,
      parentTranslateX = _parentTransform$tran.x,
      parentTranslateY = _parentTransform$tran.y; // Note, this order or operations matters see preview-canvas/snapPreview/imageData/README.md

  var parentTransformMatrix = (0, _getMatrix["default"])(parentScaleX, parentScaleY, parentTranslateX, parentTranslateY, parentRotation); // Multiply the matrices to get translation coordinates.
  // Use math for alpha, rotation, and scale

  parentTransformMatrix.multiply(elementTransformMatrix);
  var combinedAlpha = alpha * parentAlpha;
  var combinedRotation = rotation + parentRotation;
  var combinedScale = {
    x: scaleX * parentScaleX,
    y: scaleY * parentScaleY
  };

  var _parentTransformMatri = parentTransformMatrix.decompose(),
      combinedTranslation = _parentTransformMatri.translate;

  var combinedFilters = (0, _combineParentAndChildFilters["default"])(parentFilters, childFilters);
  return {
    alpha: combinedAlpha,
    filters: combinedFilters,
    rotation: combinedRotation,
    scale: combinedScale,
    translation: combinedTranslation
  };
};

var _default = combineParentAndChildTransforms;
exports["default"] = _default;